// Carga la siguiente página de productos por AJAX y la añade a la cuadrícula
// actual, en vez de recargar la página y saltar al inicio (que es lo que hacía
// la paginación clásica por números). El enlace sigue siendo un <a href> real
// apuntando a la página siguiente, así que si JavaScript falla por lo que sea,
// sigue funcionando como una navegación normal.
class LoadMoreProducts extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.collection-load-more__button');
    this.spinner = this.querySelector('.loading__spinner');
    if (!this.button) return;
    this.button.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();
    if (this.loading) return;
    this.loading = true;

    const url = this.button.getAttribute('href');
    const sectionId = this.dataset.sectionId;
    const separator = url.indexOf('?') === -1 ? '?' : '&';

    this.button.setAttribute('aria-disabled', 'true');
    if (this.spinner) this.spinner.classList.remove('hidden');

    const gridId = this.dataset.gridId || 'product-grid';

    fetch(url + separator + 'section_id=' + sectionId)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const newGrid = html.getElementById(gridId);
        const currentGrid = document.getElementById(gridId);
        if (newGrid && currentGrid) {
          currentGrid.append(...newGrid.children);
        }

        const newLoadMore = html.querySelector('load-more-products');
        if (newLoadMore && newLoadMore.querySelector('.collection-load-more__button')) {
          this.replaceWith(newLoadMore);
        } else {
          this.remove();
        }
      })
      .catch(() => {
        window.location.href = url;
      });
  }
}

customElements.define('load-more-products', LoadMoreProducts);
